import { render } from "./CategoryCard.vue?vue&type=template&id=734caa8c"
import script from "./CategoryCard.vue?vue&type=script&lang=js"
export * from "./CategoryCard.vue?vue&type=script&lang=js"

import "./CategoryCard.vue?vue&type=style&index=0&id=734caa8c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tests/CategoryCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "734caa8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('734caa8c', __exports__)) {
    api.reload('734caa8c', __exports__)
  }
  
  module.hot.accept("./CategoryCard.vue?vue&type=template&id=734caa8c", () => {
    api.rerender('734caa8c', render)
  })

}


export default __exports__